export enum MarketingReservoir {
  BIBLIOTECA_GENERAL = 'MARKETING_Biblioteca',
  SLIDER = 'MARKETING_Slider',
  BENEFICIOS_CATEGORIAS = 'MARKETING_Categorias_Alianzas',
  BENEFICIOS_SUBCATEGORIAS = 'MARKETING_Subcategorias_Alianzas',
  BENEFICIOS_ITEMS = 'MARKETING_Beneficios_Alianzas',
  MANUALES_CATEGORIAS = 'MARKETING_Categorias_Manuales_de_Marca',
  MANUALES_ITEMS = 'MARKETING_Manuales_de_Marca',
  PROMOCIONES_CATEGORIAS = 'MARKETING_Categorias_Piezas_de_Campana',
  PROMOCIONES_SUBCATEGORIAS = 'MARKETING_Subcategorias_Piezas_de_Campana',
  PROMOCIONES_ITEMS = 'MARKETING_Piezas_de_Campana',
  COMUNICACION_CATEGORIAS = 'MARKETING_Categorias_Piezas_Comunicacion_Digital',
  COMUNICACION_SUBCATEGORIAS = 'MARKETING_Subcategorias_Piezas_Comunicacion_Digital',
  COMUNICACION_ITEMS = 'MARKETING_Piezas_Comunicacion_Digital',
}
